import { LitElement, html, css, PropertyValues } from 'lit'
import {customElement, property} from 'lit/decorators.js'
import { v4 as uuid } from 'uuid'
import '../components/vxc_sidebar'
import '../components/vxc_chatbot_editor'
import '../components/styles/iconlibrary'
import '@shoelace-style/shoelace/dist/components/button/button'
import SlButton from '@shoelace-style/shoelace/dist/components/button/button'
import { SlMenuItem } from '@shoelace-style/shoelace'


@customElement('vxa-iamie-dashboard')
class TIAmieDashboard extends LitElement {
    static styles = css`
    :host { 
        display: block;
        min-height: 100vh;
        margin: 0;
    }

    .menu-item {
        width: 100%;
        margin-bottom: .5rem;
    }

    .header {
        display: flex; 
        justify-content: space-between; 
        align-items: center; 
        padding: 0.5rem; 
        background-color: white;
        boder: 1px solid #CCC;
        box-shadow: rgba(1, 41, 112, 0.1) 0px 0px 30px 0px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        margin-bottom: 1rem;
    }

    .brand {
        font-size: 1.2rem;
    }

    `

    @property({ type: Boolean, attribute: false })      loggedIn: boolean = false
    @property({ type: Array  , attribute: false })      apps  : Array<any> = []
    @property({ type: String , attribute: false })      appID?: string

    constructor() {
        super();
    }

    private handleLogin(event: CustomEvent) {
        try {
            console.log('handleLogin')
            this.listApps()
        }
        catch(e) { console.error(e) }
    }

    private handleLogout() {
        console.log('logged out', this, this.loggedIn)
        this.loggedIn = false
        this.apps = []
    }

    private handleUserMenu(event: CustomEvent) {
        try {
            let slMenuItem = event.detail.item as SlMenuItem
            console.log('menu clck', slMenuItem.value)
            switch(slMenuItem.value) {
                case 'disconnect':
                    console.log('clicked disconnect..')
                    window.voxyapp.logout()
                    break
            }
        }
        catch(e) { console.error(e) }
    }

    private async listApps() {
        try {
            console.log('list apps')
            if(!window.voxyapp)     throw new Error('app not initialized')
            let apps = await window.voxyapp.get('/apps')
            console.log('apps :', apps)
            if(!apps)    throw new Error('no apps found')
            this.loggedIn = window.voxyapp.loggedIn()
            this.apps = apps
        }
        catch(e) { console.error(e) }

    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('logout', () => this.handleLogout())
        this.addEventListener('app-updated', () => this.listApps() )
    }

    disconnectedCallback() {
        window.removeEventListener('logout', () => this.handleLogout())
        super.disconnectedCallback();
    }

    private createApp(event: Event) {
        try {
            console.log('create App')
            this.appID = 'new'
        }
        catch(e) { console.error('error creating app')}
    }

    private editApp(event: Event) {
        try {
            let slButton = event.target as SlButton
            let appUID = slButton.getAttribute('data-uid')
            if(!appUID)     throw new Error('no app UID found !')
            console.log('edit app', appUID)
            this.appID = appUID
        }
        catch(e) { console.error('error editiing app')}
    }

    render() {
        console.log('dashboard rendering..', this.loggedIn)
        if(this.loggedIn) {
            return html`
                <vxc-sidebar>
                    <div slot="menu">
                        <div style="margin-top: 5rem">
                            <sl-button class="menu-item" variant="success" size="medium" @click=${this.createApp}>
                                new ChatBot
                            </sl-button><hr/>
                            ${this.apps.map( app => html`
                                <sl-button class="menu-item" data-uid=${app.uid} variant="default" size="small" @click=${this.editApp}>
                                    ${app.name||'ChatBot'}
                                </sl-button>
                                `)}
                        </div>
                    </div>

                    <div class="main">
                        <div class="header">
                            <div class="brand"><sl-icon name="feather" library="voxy-icons" style="font-size: 2rem;"></sl-icon> IAMIE Chat Bot Platform.</div>

                            <sl-dropdown>
                                <sl-icon-button name="gear" slot="trigger" library="voxy-icons" style="font-size: 1.5rem;"></sl-icon-button>
                                <sl-menu
                                    @sl-select=${this.handleUserMenu}>
                                    <sl-menu-item value="disconnect">disconnect</sl-menu-item>
                                </sl-menu>
                            </sl-dropdown>
                        </div>

                        ${this.appID === undefined
                            ? html``
                            : this.appID === 'new'
                                ? html`<vxc-chatbot-editor></vxc-chatbot-editor>`
                                : html`<vxc-chatbot-editor app-uid="${this.appID}"></vxc-chatbot-editor>`}    
                    </div>
                </vxc-sidebar>  
            `
        }
        else {
            return html`
                <vxc-login
                    @logged-in=${this.handleLogin}
                ></vxc-login>
            `
        }
    }
}


declare global {
  interface HTMLElementTagNameMap {
    'vxa-iamie-dashboard': TIAmieDashboard;
  }
}

// ${this.appID === 'new' ? '' : html`app-uid=${this.appID}`}